module.exports = __webpack_public_path__ + "static/media/banner_03.19abff76.png";